import './recent-products.scss';
